import { toast } from "react-toastify";

export const toastr = toast;
